.label {
	margin-right: 5px;
	font-weight: bold;
}
.disable-events {
	/* pointer-events: none; */
}
